import React, { Component } from "react";
import { translate } from "react-polyglot";

interface IProps {
  openUpdateModal: (buildup: any) => void;
  searchedBuildups: any[];
  columnList: any[];
}

class OfflineDataTable extends Component<IProps & TranslateProps> {
  public render() {
    const { searchedBuildups, columnList, openUpdateModal, t } = this.props;

    if (searchedBuildups.length === 0) {
      return (
        <tr>
          <td>{t("errors.noSearchResults")}</td>
        </tr>
      );
    }
    return searchedBuildups.map((buildup: any) => {
      const { id, name, description, ...parameters } = buildup;

      return (
        <tr key={id} onClick={() => openUpdateModal(buildup)}>
          <td>{name}</td>
          <td>{description}</td>
          {columnList.map(p => {
            return <td key={p}>{parameters[p]}</td>;
          })}
        </tr>
      );
    });
  }
}

export default translate()(OfflineDataTable);
